import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExecutionRoutingModule } from './execution-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExecutionRoutingModule 
  ]
})
export class ExecutionModule { }
